import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
const ConfirmDeleteDialogNote = ({ open, onClose, onConfirm, parent }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {parent === "account_assignment"
          ? I18n.get("Delete Note Pattern")
          : I18n.get("Delete Note Pattern")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {parent === "account_assignment"
            ? I18n.get(
                "Are you sure you want to delete this Note Pattern?"
              )
            : I18n.get(
                "Are you sure you want to delete this Note Pattern?"
              )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {I18n.get("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialogNote;
